import { render, staticRenderFns } from "./LivePopularity.vue?vue&type=template&id=a18837a2&scoped=true"
import script from "./LivePopularity.vue?vue&type=script&lang=js"
export * from "./LivePopularity.vue?vue&type=script&lang=js"
import style0 from "./LivePopularity.vue?vue&type=style&index=0&id=a18837a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18837a2",
  null
  
)

export default component.exports